import { Button, Modal, Spinner } from 'react-bootstrap';
import Layout2 from '../layouts/Layout2';
import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import KoreaBankInfo from "../components/KoreaBankInfo";
import { FileUploader } from "react-drag-drop-files";
import '../App.css';

const Credit = () => {
    const endpointURL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE;
    const [isLoading, setIsLoading] = useState(false);
    const fileTypes = ["JPEG", "JPG", "PNG"];
    const [submitted, setSubmitted] = useState(false);
    const [data, setData] = useState([]);
    const [creditWon, setCreditWon] = useState(0);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const navigate = useNavigate();
    const [errors, setErrors] = useState({
        uploadFile: null,
    });
    const [values, setValues] = useState({
        uploadFile: null,
    });
    
    const fetchData = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(endpointURL + "/api/v1/getCreditTransactions", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                },
                body: JSON.stringify({}),
            });
            if (!response.ok) {
                console.log("error resp");
            }
            const result = await response.json();
            if (result.status == true) {
                setData(result.data);
                setCreditWon(result.creditWon);
            } else {
                console.log("response fail");
            }
        } catch (error) {
            console.log("error catch")
        }
        setIsLoading(false);
    }
    
    const viewTransaction = (data) => {
        navigate('/transaction-view', { state: data });
    }
    
    const toPaidCredit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        await Swal.fire({
            title: "<span style='color:#000'>အကြွေးဆပ်မှာလား?</span>",
            showCancelButton: true,
            width: 350,
            confirmButtonText: "အတည်ပြုမည်",
        }).then(async (result) => {
            if (result.isConfirmed) {
                if (!submitted) {
                    setSubmitted(true);
                    try {
                        const formData = new FormData();
                        formData.append('uploadFile', values.uploadFile);
                        const response = await fetch(endpointURL + "/api/v1/toPaidCredit", {
                            method: 'POST',
                            headers: {
                                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                            },
                            body: formData,
                        });

                        if (!response.ok) {
                            throw new Error('Request failed');
                        }
                        const resp = await response.json();
                        if (resp.status === true) {
                            setShow(false);
                            setValues({
                                uploadFile: null,
                            });
                            Swal.fire({
                                title: resp.msg,
                                width: 300,
                            });
                            fetchData();
                        } else {
                            setErrors(errors => ({
                                ...errors,
                                uploadFile: resp.data.uploadFile
                            }));
                        }
                    } catch (error) {
                        Swal.fire({
                            title: error,
                            width: 300,
                        });
                    }
                    setSubmitted(false);
                }
            }
        });
        setIsLoading(false);
    }
    
    const handleFile = (file) => {
        setValues(values => ({
            ...values,
            uploadFile: file,
        }));
    };
    
    const viewPaidTransaction = () => {
        navigate('/credit-paid-transaction');
    }
    
    useEffect(() => {
        if (localStorage.getItem('token') == null || localStorage.getItem('token') == "") {
            Swal.fire({
                text: "Telegram ဖြင့် Login ဝင်ပါ",
                width: 400,
            });
            navigate("/");
        }
        fetchData();
    }, []);
    
    return (
        <>
            <Layout2 pageType="အကြွေးစာရင်းများ">
                <Helmet>
                    <title>အကြွေးစာရင်းများ</title>
                </Helmet>
                <div className="credit-container">
                    <div className="credit-header">
                        <h6>အကြွေးစာရင်းများနှင့် လက်ကျန်ကြွေး</h6>
                    </div>
                    
                    <div className="credit-actions">
                        <div className="credit-balance">
                            {creditWon} ₩
                        </div>
                        <button className="credit-history-btn" onClick={viewPaidTransaction}>
                            အကြွေးဆပ်စာရင်း
                        </button>
                    </div>
                    
                    {
                        isLoading ?
                            <div className="transaction-loading">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                                <p>လုပ်ဆောင်နေသည်...ခဏစောင့်ပါ</p>
                            </div>
                            :
                            data.length > 0 ?
                                <div className="credit-list">
                                    {data.map((list) => (
                                        <div key={list.id} onClick={(e) => viewTransaction(list)} className="credit-item">
                                            <div className="credit-item-header">
                                                <img src={`./${list.image}`} className="credit-logo" alt="Logo"></img>
                                                <div className="credit-info">
                                                    <div className="credit-name">{list.pay_name}</div>
                                                    <div className="credit-badges">
                                                        {(list.status_id == "2" && list.credit == "0") || (list.status_id == "3" && list.credit == "0") ?
                                                            <span className="credit-badge paid">Paid</span> : ""}
                                                        {(list.status_id == "2" && list.credit == "1") || (list.status_id == "3" && list.credit == "1") ?
                                                            <span className="credit-badge credit">Credit</span> : ""}
                                                    </div>
                                                </div>
                                                <div className="credit-amount">{list.kyat} MMK</div>
                                            </div>
                                            <div className="credit-details">
                                                <span className="credit-date">
                                                    {list.date} {list.time}
                                                    {list.credit === 1 && list.paid_token !== null ?
                                                        <span className="credit-payment-status paid"> ငွေလွှဲပြီး</span> :
                                                        <span className="credit-payment-status unpaid"> အကြွေးဆပ်ရန်နှိပ်ပါ</span>
                                                    }
                                                </span>
                                                <span className={`credit-status ${list.status_id == 1 ? 'pending' : 'completed'}`}>
                                                    {list.status_name}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                :
                                (
                                    <div className="transaction-empty">အကြွေးစာရင်းမရှိပါ...</div>
                                )
                    }
                </div>
                
                <Modal show={show} onHide={handleClose} centered>
                    <Modal.Header className="credit-modal-header">
                        <Modal.Title className="credit-modal-title">
                            အကြွေးဆပ်ရန် အချက်လက်ဖြည့်သွင်းပါ
                        </Modal.Title>
                    </Modal.Header>
                    <form onSubmit={toPaidCredit}>
                        <Modal.Body className="credit-modal-body">
                            <KoreaBankInfo />
                            <hr />
                            <div className="form-group">
                                <label className="credit-form-label">
                                    အကြွေးဆပ် ဝမ်ငွေလွှဲစလစ် <b style={{ color: "#ff4757" }}>*</b>
                                </label>
                                <div className="credit-file-upload">
                                    <FileUploader handleChange={handleFile} name="file" types={fileTypes}></FileUploader>
                                </div>
                                <label className="credit-file-error">{errors.uploadFile}</label>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="credit-modal-footer">
                            <Button type="submit" className="credit-submit-btn">
                                <i className="bx bx-save"></i>
                                {isLoading ? "Loading..." : "ပေးပို့မည်"}
                            </Button>
                            <Button className="credit-cancel-btn" onClick={handleClose}>
                                ပိတ်မည်
                            </Button>
                        </Modal.Footer>
                    </form>
                </Modal>
            </Layout2>
        </>
    );
}

export default Credit;